module.exports = __webpack_public_path__ + "img/elf_16.002487fb.png";